import React from "react";
import { Skeleton, TableCell, TableRow } from "@mui/material";

export default function TableSkeleton({ rows = 5, cols = 5 }) {
  return Array.from({ length: rows }).map((_, r) => (
    <TableRow key={r}>
      {Array.from({ length: cols }).map((__, c) => (
        <TableCell key={c}><Skeleton variant="text" width={c === 0 ? "60%" : "80%"} /></TableCell>
      ))}
    </TableRow>
  ));
}
